theme.Filters = (function () {
	var settings = {
		mediaQueryMediumUp: "(min-width: " + theme.breakpoints.medium + "px)",
	};

	var selectors = {
		filterSelection: "#FilterTags",
		sortSelection: "#SortBy",
		selectInput: "[data-select-input]",
	};

	function Filters(container) {
		this.filterSelect = container.querySelector(selectors.filterSelection);
		this.sortSelect = container.querySelector(selectors.sortSelection);

		this.selects = document.querySelectorAll(selectors.selectInput);

		if (this.sortSelect) {
			this.defaultSort = this._getDefaultSortValue();
		}

		if (this.selects.length) {
			this.selects.forEach(function (select) {
				select.classList.remove("hidden");
			});
		}

		this.initBreakpoints = this._initBreakpoints.bind(this);

		this.mql = window.matchMedia(settings.mediaQueryMediumUp);
		this.mql.addListener(this.initBreakpoints);

		if (this.filterSelect) {
			this.filterSelect.addEventListener(
				"change",
				this._onFilterChange.bind(this)
			);
		}

		if (this.sortSelect) {
			this.sortSelect.addEventListener(
				"change",
				this._onSortChange.bind(this)
			);
		}

		theme.Helpers.promiseStylesheet().then(
			function () {
				this._initBreakpoints();
			}.bind(this)
		);
		this._initParams();
	}

	Filters.prototype = Object.assign({}, Filters.prototype, {
		_initBreakpoints: function () {
			if (this.mql.matches) {
				slate.utils.resizeSelects(this.selects);
			}
		},

		_initParams: function () {
			this.queryParams = {};
			if (location.search.length) {
				var aKeyValue;
				var aCouples = location.search.substr(1).split("&");
				for (var i = 0; i < aCouples.length; i++) {
					aKeyValue = aCouples[i].split("=");
					if (aKeyValue.length > 1) {
						this.queryParams[decodeURIComponent(aKeyValue[0])] =
							decodeURIComponent(aKeyValue[1]);
					}
				}
			}
		},

		_onSortChange: function () {
			this.queryParams.sort_by = this._getSortValue();

			if (this.queryParams.page) {
				delete this.queryParams.page;
			}

			window.location.search = decodeURIComponent(
				new URLSearchParams(Object.entries(this.queryParams)).toString()
			);
		},

		_onFilterChange: function () {
			document.location.href = this._getFilterValue();
		},

		_getFilterValue: function () {
			return this.filterSelect.value;
		},

		_getSortValue: function () {
			return this.sortSelect.value || this.defaultSort;
		},

		_getDefaultSortValue: function () {
			return this.sortSelect.dataset.defaultSortby;
		},

		onUnload: function () {
			if (this.filterSelect) {
				this.filterSelect.removeEventListener(
					"change",
					this._onFilterChange
				);
			}

			if (this.sortSelect) {
				this.sortSelect.removeEventListener(
					"change",
					this._onSortChange
				);
			}

			this.mql.removeListener(this.initBreakpoints);
		},
	});

	return Filters;
})();

document.addEventListener('sectionregister', function() {
    sections.register('collection-template', theme.Filters);
});